import { database } from './firebase';
import { ref, push, set, onValue, update, get } from 'firebase/database';

export class RutasService {
  static async guardarRuta(ruta) {
    const rutasRef = ref(database, 'rutas');
    const nuevaRutaRef = push(rutasRef);
    const data = {
      id: nuevaRutaRef.key,
      ...ruta,
      fechaCreacion: new Date().toISOString(),
      timestamp: Date.now()
    };
    await set(nuevaRutaRef, data);
    return data;
  }

  static suscribirseRutas(callback) {
    const rutasRef = ref(database, 'rutas');
    return onValue(rutasRef, (snapshot) => {
      const rutas = [];
      snapshot.forEach((child) => rutas.push(child.val()));
      callback(rutas);
    });
  }

  static async asignarRutaARRepartidor(rutaId, repartidor) {
    const rutaRef = ref(database, `rutas/${rutaId}`);
    await update(rutaRef, { asignadaA: repartidor, estado: 'asignada' });
  }
}

